import { FC, SVGAttributes } from 'react';

type FlowerSvgProps = SVGAttributes<SVGElement>;

export const FlowerSvg: FC<FlowerSvgProps> = ({ ...props }) => {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.0015 0C18.1494 0.869425 19.8445 2.62365 20.6351 4.81061C22.741 3.82227 25.1809 3.78028 27.3152 4.68451C28.2198 6.81973 28.1774 9.26079 27.1878 11.3673C29.3755 12.1576 31.1303 13.8531 32 16.0015C31.1306 18.1491 29.3769 19.8441 27.1902 20.6348C28.1787 22.7408 28.2207 25.1808 27.3164 27.3152C25.1818 28.2196 22.7415 28.1774 20.6354 27.1886C19.8449 29.376 18.1496 31.1305 16.0015 32C13.8526 31.1301 12.1568 29.3749 11.3668 27.1864C9.2611 28.1744 6.82161 28.2162 4.68763 27.3121C3.78384 25.179 3.82533 22.7407 4.81199 20.6356C2.62433 19.8453 0.869612 18.1499 0 16.0015C0.869987 13.8523 2.62565 12.1564 4.81436 11.3665C3.82658 9.26085 3.78478 6.82148 4.68888 4.68763C6.82255 3.78359 9.26153 3.82533 11.367 4.8128C12.1572 2.62477 13.8528 0.869737 16.0015 0Z"
                fill="#e46447"
            />
        </svg>
    );
};
